import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { TermsStateData, UpdateTermsInput } from "~/gql/graphqlBase.generated";

interface TermsState {
	editTermsInput?: UpdateTermsInput;
	termsStateData?: TermsStateData;
}

const initialState: TermsState = {};

export const termsSlice = createSlice({
	initialState,
	name: "terms",
	reducers: {
		setEditTermsInput: (state, action: PayloadAction<UpdateTermsInput | null>) => {
			if (action.payload === null) {
				state.editTermsInput = undefined;
				return;
			}
			state.editTermsInput = { ...action.payload };
		},
		setTerms: (state, action: PayloadAction<TermsStateData | null>) => {
			if (action.payload === null) {
				state.termsStateData = undefined;
				state.editTermsInput = undefined;
				return;
			}
			state.termsStateData = { ...action.payload };
		},
		updateEditTermsInput: (state, action: PayloadAction<Partial<UpdateTermsInput>>) => {
			if (!action.payload) {
				state.editTermsInput = undefined;
			} else {
				if (!state.editTermsInput) return;
				state.editTermsInput = { ...state.editTermsInput, ...action.payload };
			}
		},
		updateTerms: (state, action: PayloadAction<Partial<TermsStateData>>) => {
			if (!action.payload) {
				state.termsStateData = undefined;
			} else {
				if (!state.termsStateData) return;
				state.termsStateData = { ...state.termsStateData, ...action.payload };
			}
		}
	}
});

export const { setEditTermsInput, setTerms, updateEditTermsInput, updateTerms } = termsSlice.actions;

export default termsSlice.reducer;
